import styled from 'styled-components';

export const DrawerMainLeft = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;

  .emp-ant-form {
    .emp-ant-form-item {
      margin-bottom: 6px;

      .emp-ant-input {
        &::placeholder {
          color: rgba(0, 0, 0, 0.45);
        }

        &-disabled,
        &[disabled] {
          color: rgba(0, 0, 0, 0.88);
        }
      }

      .emp-ant-select {
        &-disabled {
          .emp-ant-select-selector {
            color: rgba(0, 0, 0, 0.88);
          }
        }
      }
    }
  }
`;

export const DrawerMainRight = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
  flex-shrink: 0;
`;
